"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _metrics = require("@studio/metrics");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function SignalIcon(_ref) {
  var toolTipId = _ref.toolTipId,
    health = _ref.health,
    tooltipShown = _ref.tooltipShown,
    isLightTheme = _ref.isLightTheme,
    attendeeId = _ref.attendeeId,
    _ref$trackMouseEnter = _ref.trackMouseEnter,
    trackMouseEnter = _ref$trackMouseEnter === void 0 ? true : _ref$trackMouseEnter;
  var colors = ['#5C617C', '#5C617C', '#5C617C', '#5C617C', '#5C617C'];
  if (tooltipShown || isLightTheme) {
    colors = ['#DFE3EC', '#DFE3EC', '#DFE3EC', '#DFE3EC', '#DFE3EC'];
    switch (health) {
      case 'poor':
        colors = ['#DFE3EC', '#DE2F1B', '#DE2F1B', '#DFE3EC', '#DFE3EC'];
        break;
      case 'good':
        colors = ['#DFE3EC', '#575D67', '#575D67', '#575D67', '#DFE3EC'];
        break;
      case 'excellent':
        colors = ['#5EC298', '#5EC298', '#5EC298', '#5EC298', '#5EC298'];
        break;
      default:
        break;
    }
  } else {
    switch (health) {
      case 'poor':
        colors = ['#5C617C', '#DE2F1B', '#DE2F1B', '#5C617C', '#5C617C'];
        break;
      case 'good':
        colors = ['#5C617C', 'white', 'white', 'white', '#5C617C'];
        break;
      case 'excellent':
        colors = ['#5EC298', '#5EC298', '#5EC298', '#5EC298', '#5EC298'];
        break;
      default:
        break;
    }
  }

  /**
   * Track view tooltip action
   */
  var _useNetworkhealthPage = (0, _metrics.useNetworkhealthPageActionsApi)(),
    userViewsNetworkHealthTooltip = _useNetworkhealthPage.userViewsNetworkHealthTooltip;
  var trackViewTooltip = (0, _react.useCallback)(function () {
    userViewsNetworkHealthTooltip({
      chimeAttendeeId: attendeeId
    });
  }, [attendeeId, userViewsNetworkHealthTooltip]);
  var eventHandlers = trackMouseEnter ? {
    onMouseEnter: trackViewTooltip
  } : {};
  return _react["default"].createElement("div", (0, _extends2["default"])({
    id: toolTipId
  }, eventHandlers), _react["default"].createElement("svg", {
    role: "img",
    "aria-label": "Network quality: ".concat(health),
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    clipPath: "url(#clip0)"
  }, _react["default"].createElement("path", {
    d: "M16.212 0.517792H14.9147C14.6715 0.517792 14.4823 0.767792 14.4823 1.01779V16.0178C14.4823 16.299 14.6715 16.5178 14.9147 16.5178H16.212C16.4282 16.5178 16.6445 16.299 16.6445 16.0178V1.01779C16.6445 0.767792 16.4282 0.517792 16.212 0.517792Z",
    fill: colors[0]
  }), _react["default"].createElement("path", {
    d: "M1.07684 12.5178H2.37414C2.59036 12.5178 2.80657 12.7678 2.80657 13.0178V16.0178C2.80657 16.299 2.59036 16.5178 2.37414 16.5178H1.07684C0.833598 16.5178 0.644409 16.299 0.644409 16.0178V13.0178C0.644409 12.7678 0.833598 12.5178 1.07684 12.5178Z",
    fill: colors[1]
  }), _react["default"].createElement("path", {
    d: "M4.53631 9.51779H5.83361C6.04983 9.51779 6.26604 9.76779 6.26604 10.0178V16.0178C6.26604 16.299 6.04983 16.5178 5.83361 16.5178H4.53631C4.29307 16.5178 4.10388 16.299 4.10388 16.0178V10.0178C4.10388 9.76779 4.29307 9.51779 4.53631 9.51779Z",
    fill: colors[2]
  }), _react["default"].createElement("path", {
    d: "M7.99579 6.51779H9.29308C9.5093 6.51779 9.72552 6.76779 9.72552 7.01779V16.0178C9.72552 16.299 9.5093 16.5178 9.29308 16.5178H7.99579C7.75254 16.5178 7.56335 16.299 7.56335 16.0178V7.01779C7.56335 6.76779 7.75254 6.51779 7.99579 6.51779Z",
    fill: colors[3]
  }), _react["default"].createElement("path", {
    d: "M11.4553 3.51779H12.7526C12.9688 3.51779 13.185 3.76779 13.185 4.01779V16.0178C13.185 16.299 12.9688 16.5178 12.7526 16.5178H11.4553C11.212 16.5178 11.0228 16.299 11.0228 16.0178V4.01779C11.0228 3.76779 11.212 3.51779 11.4553 3.51779Z",
    fill: colors[4]
  })), _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
    id: "clip0"
  }, _react["default"].createElement("rect", {
    width: "16",
    height: "16",
    fill: "white",
    transform: "translate(0.644409 0.517792)"
  })))));
}
var _default = exports["default"] = SignalIcon;